const DashboardPDFFormat = Object.freeze({
  SINGLE: 'SINGLE',
  PORTRAIT: 'PORTRAIT',
  LANDSCAPE: 'LANDSCAPE'
})
export default DashboardPDFFormat
export type DashboardPDFFormatStrings = typeof DashboardPDFFormat[keyof typeof DashboardPDFFormat]
// RESERVE BELOW
